export default "__VITE_ASSET__f4fa0cb0__"